// extracted by mini-css-extract-plugin
export var label = "_jz-2";
export var slideContainer = "_jz-0";
export var slider = "_jz-1";